<template>
  <div id="menuzone">
    <ul class="menu">

      <li v-for="(item, index) in items" :class="[{'open selected activeSelected' : item.path === $route.path.replace(/(\/\w+)\/$/, '$1')}, {first : index === 0}, {last : index === (items.length - 1)}]">
        <router-link :to="item.path">
          <span><span>{{ item.name }}</span></span>
        </router-link>
      </li>

    </ul>
  </div>
</template>

<script>
  export default {
    name: 'app-menu',
    data () {
      return {
        items: [
          {
            name: 'Úvod',
            path: '/'
          }, {
            name: 'O nás',
            path: '/about'
          }, {
            name: 'Služby',
            path: '/service'
          }, {
            name: 'Masáže',
            path: '/massage'
          }, {
            name: 'Dárkové poukazy',
            path: '/voucher'
          }, {
            name: 'Kontakt',
            path: '/contact'
          }]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AppMenu.vue?6b5b851d